export default "__VITE_ASSET__BBikz72b__"